import { motion } from "framer-motion";
import { Check, Award, Quote } from "lucide-react";
import { FOUNDER, PHOTOS } from "./data";

const ease = [0.16, 1, 0.3, 1];

export const Founder = () => (
  <section id="founder" className="relative py-24 md:py-36 bg-pine text-bone overflow-hidden" data-testid="founder">
    <div className="noise-overlay" />
    <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease }}
        className="lg:col-span-5"
      >
        <div className="relative aspect-[4/5] overflow-hidden">
          <img
            src={PHOTOS.joshua}
            alt="Joshua Galstaun — JD Sir"
            data-testid="founder-photo"
            className="w-full h-full object-cover object-[74%_47%] origin-[74%_47%] scale-[1.45]"
          />
          <div className="absolute inset-0 ring-1 ring-inset ring-bone/15" />
        </div>
        <div className="mt-4 bg-terra text-white px-5 py-4">
          <p className="font-serif text-2xl leading-none">
            {FOUNDER.name}
            <span className="ml-1 text-base italic text-white/85">{FOUNDER.nameSuffix}</span>
          </p>
          <p className="text-xs mt-2 italic text-white/80">{FOUNDER.aka}</p>
        </div>

        <div className="mt-4 bg-bone/10 border-l-4 border-terra p-6" data-testid="founder-personal-quote">
          <Quote className="w-6 h-6 text-terra mb-3" />
          <p className="font-serif text-lg md:text-xl italic leading-snug text-bone/90">{FOUNDER.quote}</p>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease, delay: 0.1 }}
        className="lg:col-span-7"
      >
        <p className="text-xs tracking-[0.22em] uppercase font-semibold text-terra mb-5">Meet Your Facilitator</p>
        <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-bone">
          Who is <span className="italic text-terra">JD Sir?</span>
        </h2>
        <p className="mt-3 font-serif text-xl md:text-2xl italic text-bone/85">{FOUNDER.roles}</p>
        <p className="mt-1 text-xs text-bone/50">{FOUNDER.rolesNote}</p>
        <p className="mt-6 text-bone/80 md:text-lg leading-relaxed max-w-2xl">{FOUNDER.intro}</p>

        <div className="mt-10 flex flex-wrap gap-2.5">
          {FOUNDER.credentials.map((c) => (
            <span key={c} className="flex items-center gap-2 text-xs md:text-sm bg-bone/10 border border-bone/15 px-3 py-2">
              <Award className="w-3.5 h-3.5 text-terra shrink-0" /> {c}
            </span>
          ))}
        </div>

        <ul className="mt-10 space-y-4 border-t border-bone/15 pt-8">
          {FOUNDER.points.map((p) => (
            <li key={p} className="flex items-start gap-3 text-bone/85 md:text-lg">
              <span className="mt-1.5 w-5 h-5 shrink-0 bg-terra/20 flex items-center justify-center">
                <Check className="w-3.5 h-3.5 text-terra" strokeWidth={2.5} />
              </span>
              {p}
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  </section>
);
